webpackJsonp([172738306733558],{

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ExamplePage = __webpack_require__(6);
	
	var _ExamplePage2 = _interopRequireDefault(_ExamplePage);
	
	var _CodeSample = __webpack_require__(5);
	
	var _CodeSample2 = _interopRequireDefault(_CodeSample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _ExamplePage2.default,
	    { title: 'Inline-style days cells' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can apply a custom inline style to day cells using modifiers. The following example add a custom ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'birthday'
	      ),
	      ' modifier for a specific day and a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'monday'
	      ),
	      ' modifiers to match all the Mondays.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Day cells can also formatted',
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/examples/modifiers' },
	        'using CSS classes'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'examples/modifiers-styles' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-modifiers-styles-js-21e7140caa09b04d6109.js